import DOMPurify from 'isomorphic-dompurify';

interface Props {
    print: string | undefined;
    stripTags?: string[];
    tag?: 'span' | 'div' | 'p';
    className?: string;
    config?: DOMPurify.Config;
}

export default function SafeHtml({
    print = '',
    stripTags = [],
    tag = 'span',
    className,
    config = {},
}: Props): React.JSX.Element {
    const Tag = tag;
    config.RETURN_DOM_FRAGMENT = false;
    config.RETURN_DOM = false;

    let cleanHTML = DOMPurify.sanitize(print, config) as string;

    stripTags.forEach((tag) => {
        const rx = new RegExp(`<\/?${tag}>`, 'gmi');
        cleanHTML = cleanHTML.replace(rx, '');
    });

    if (cleanHTML) {
        return <Tag className={className} dangerouslySetInnerHTML={{ __html: cleanHTML }} />;
    }

    return <></>;
}
